import {
  Component, OnInit, AfterViewInit, AfterViewChecked,
  OnDestroy, Input, Output, EventEmitter, ElementRef, Renderer2, ChangeDetectorRef, HostListener, HostBinding
} from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
@Component({
  selector: 'app-overlay-panel',
  templateUrl: './overlay-panel.component.html',
  styleUrls: ['./overlay-panel.component.css'],
  animations: [
    trigger('panelState', [
      state('hidden', style({
        opacity: 0
      })),
      state('visible', style({
        opacity: 1
      })),
      transition('visible => hidden', animate('400ms ease-in')),
      transition('hidden => visible', animate('400ms ease-out'))
    ])
  ],
  standalone: false
})
export class OverlayPanelComponent implements AfterViewInit, AfterViewChecked, OnDestroy {

  @Input() dismissable = true;

  @Input() showCloseIcon: boolean;

  @Input() style: any;

  @Input() styleClass: string;

  @Input() appendTo: any;

  @Output() beforeShow = new EventEmitter();

  @Output() afterShow = new EventEmitter();

  @Output() beforeHide = new EventEmitter();

  @Output() afterHide = new EventEmitter();
  @HostBinding('tabindex') tabindex = '-1';

  container: any;

  visible = false;

  documentClickListener: any;

  selfClick: boolean;

  target: any;

  willHide: boolean;

  willShow: boolean;

  targetClickEvent: boolean;

  closeClick: boolean;

  constructor(public el: ElementRef,
    public renderer: Renderer2) { }

  ngAfterViewInit() {
    this.container = this.el.nativeElement.children[0];

    if (this.appendTo) {
      if (this.appendTo === 'body') {
        document.body.appendChild(this.container);
      }

    }
  }

  ngAfterViewChecked() {
    if (this.willShow) {
      this.bindDocumentClickListener();
      this.afterShow.emit(null);
      this.willShow = false;
    }

    if (this.willHide) {
      this.afterHide.emit(null);
      this.willHide = false;
    }
  }

  bindDocumentClickListener() {
    // if (!this.documentClickListener && this.dismissable) {
    //   this.documentClickListener = this.renderer.listen('document', 'click', () => {
    //     if (!this.selfClick && !this.targetClickEvent) {
    //       this.hide();
    //     }

    //     this.selfClick = false;
    //     this.targetClickEvent = false;
    //     this.cd.markForCheck();
    //   });
    // }
  }

  unbindDocumentClickListener() {
    if (this.documentClickListener) {
      this.documentClickListener();
      this.documentClickListener = null;
    }
  }

  toggle(event, target?) {
    if (!this.target || this.target === (target || event.currentTarget || event.target)) {
      if (this.visible) {
        this.hide();
      } else {
        this.show(event, target);
      }
    } else {
      this.show(event, target);
    }
  }

  show(event, target?) {
    this.beforeShow.emit(null);
    this.target = target || event.currentTarget || event.target;

    this.visible = true;
    this.willShow = true;

    if (event.type === 'click') {
      this.targetClickEvent = true;
    }
  }

  hide() {
    if (this.visible) {
      this.beforeHide.emit(null);
      this.willHide = true;
      this.visible = false;
      this.selfClick = false;
      this.targetClickEvent = false;
      this.unbindDocumentClickListener();
    }
  }

  onPanelClick(event) {
    if (this.closeClick) {
      this.hide();
      this.closeClick = false;
    } else if (this.dismissable) {
      this.selfClick = true;
    }
  }

  onCloseClick(event) {
    this.closeClick = true;
    this.afterHide.emit();
    event.preventDefault();
  }

  ngOnDestroy() {
    this.unbindDocumentClickListener();

    if (this.appendTo) {
      this.el.nativeElement.appendChild(this.container);
    }

    this.target = null;
  }
}
